import { 
  DELIVERY_STATUS_CODES, 
  PENDING_DELIVERY_STATUSES,
  DELIVERY_STATUS_COLORS,
  DELIVERY_STATUS_TAG_TYPES 
} from '../../constants/deliveryStatus';

// 作业中心任务模块
const state = {
  // 当前选中的投递状态
  currentDeliveryStatus: '',
  // 任务统计数据
  taskStats: {
    total: 0,
    pending: 0,  // 待处理数量
    completed: 0,
    available: 0 // 有岗可约投数量
  },
  // 各状态任务数量
  statusCounts: {
    [DELIVERY_STATUS_CODES.AVAILABLE]: 0,
    [DELIVERY_STATUS_CODES.COMPLETED]: 0,
    [DELIVERY_STATUS_CODES.SERVICE_COMPLETED]: 0,
    [DELIVERY_STATUS_CODES.FORBIDDEN]: 0,
    [DELIVERY_STATUS_CODES.FROZEN]: 0,
    [DELIVERY_STATUS_CODES.SUCCESS]: 0
  },
  // 是否正在加载任务列表
  isLoading: false,
  // 最后更新时间
  lastUpdated: null
};

const getters = {
  // 获取当前投递状态
  currentDeliveryStatus: state => state.currentDeliveryStatus,
  
  // 获取任务统计
  taskStats: state => state.taskStats,
  
  // 获取有岗可约投的数量（待处理任务数）
  availableTaskCount: state => state.taskStats.available || state.statusCounts[DELIVERY_STATUS_CODES.AVAILABLE] || 0,
  
  // 获取各状态数量
  statusCounts: state => state.statusCounts,
  
  // 获取指定状态的数量
  getStatusCount: state => statusCode => state.statusCounts[statusCode] || 0,
  
  // 判断是否正在加载
  isLoading: state => state.isLoading,
  
  // 获取投递状态常量
  deliveryStatusCodes: () => DELIVERY_STATUS_CODES,
  
  // 获取待处理状态列表
  pendingStatuses: () => PENDING_DELIVERY_STATUSES,
  
  // 获取状态颜色
  getStatusColor: () => statusCode => DELIVERY_STATUS_COLORS[statusCode] || '#909399',
  
  // 获取状态标签类型
  getStatusTagType: () => statusCode => DELIVERY_STATUS_TAG_TYPES[statusCode] || 'info'
};

const mutations = {
  // 设置当前投递状态
  SET_CURRENT_DELIVERY_STATUS(state, status) {
    state.currentDeliveryStatus = status;
  },
  
  // 设置任务统计
  SET_TASK_STATS(state, stats) {
    state.taskStats = { ...state.taskStats, ...stats };
    state.lastUpdated = Date.now();
  },
  
  // 更新有岗可约投数量
  SET_AVAILABLE_TASK_COUNT(state, count) {
    state.taskStats.available = count;
    state.statusCounts[DELIVERY_STATUS_CODES.AVAILABLE] = count;
  },
  
  // 设置各状态任务数量
  SET_STATUS_COUNTS(state, counts) {
    state.statusCounts = { ...state.statusCounts, ...counts };
    // 同时更新任务统计中的相关字段
    if (counts[DELIVERY_STATUS_CODES.AVAILABLE] !== undefined) {
      state.taskStats.available = counts[DELIVERY_STATUS_CODES.AVAILABLE];
    }
  },
  
  // 设置加载状态
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  
  // 更新指定状态的数量
  UPDATE_STATUS_COUNT(state, { statusCode, count }) {
    state.statusCounts[statusCode] = count;
    if (statusCode === DELIVERY_STATUS_CODES.AVAILABLE) {
      state.taskStats.available = count;
    }
  },
  
  // 增加指定状态的数量
  INCREMENT_STATUS_COUNT(state, statusCode) {
    if (state.statusCounts[statusCode] !== undefined) {
      state.statusCounts[statusCode]++;
    } else {
      state.statusCounts[statusCode] = 1;
    }
    if (statusCode === DELIVERY_STATUS_CODES.AVAILABLE) {
      state.taskStats.available = state.statusCounts[statusCode];
    }
  },
  
  // 减少指定状态的数量
  DECREMENT_STATUS_COUNT(state, statusCode) {
    if (state.statusCounts[statusCode] && state.statusCounts[statusCode] > 0) {
      state.statusCounts[statusCode]--;
    }
    if (statusCode === DELIVERY_STATUS_CODES.AVAILABLE) {
      state.taskStats.available = state.statusCounts[statusCode];
    }
  }
};

const actions = {
  // 更新当前投递状态
  updateCurrentDeliveryStatus({ commit }, status) {
    commit('SET_CURRENT_DELIVERY_STATUS', status);
  },
  
  // 更新任务统计
  updateTaskStats({ commit }, stats) {
    commit('SET_TASK_STATS', stats);
  },
  
  // 更新有岗可约投数量
  updateAvailableTaskCount({ commit }, count) {
    commit('SET_AVAILABLE_TASK_COUNT', count);
  },
  
  // 从任务列表计算各状态数量
  calculateStatusCounts({ commit }, tasks) {
    const counts = {
      [DELIVERY_STATUS_CODES.AVAILABLE]: 0,
      [DELIVERY_STATUS_CODES.COMPLETED]: 0,
      [DELIVERY_STATUS_CODES.SERVICE_COMPLETED]: 0,
      [DELIVERY_STATUS_CODES.FORBIDDEN]: 0,
      [DELIVERY_STATUS_CODES.FROZEN]: 0,
      [DELIVERY_STATUS_CODES.SUCCESS]: 0
    };
    
    tasks.forEach(task => {
      if (counts[task.delivery_status] !== undefined) {
        counts[task.delivery_status]++;
      }
    });
    
    commit('SET_STATUS_COUNTS', counts);
    commit('SET_TASK_STATS', {
      total: tasks.length,
      available: counts[DELIVERY_STATUS_CODES.AVAILABLE]
    });
    
    return counts;
  },
  
  // 设置加载状态
  setLoading({ commit }, isLoading) {
    commit('SET_LOADING', isLoading);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
